import Nullstack from 'nullstack';
export default function IconBrandGoogleDrive({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-google-drive",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 10l-6 10l-3 -5l6 -10z"
  }), "   ", Nullstack.element("path", {
    d: "M9 15h12l-3 5h-12"
  }), "   ", Nullstack.element("path", {
    d: "M15 15l-6 -10h6l6 10z"
  }), " ");
}